<template>
  <div class="TkIntEdit full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      {{ tkIntSearchInfo.depport.cityName }}
      <van-icon
        v-show="flights.length > 1"
        name="exchange"
      />
      <span v-show="flights.length == 1">⇀</span>
      {{ tkIntSearchInfo.arrport.cityName }}
    </ld-header>

    <div class="tkIntEditwrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="box">
          <div
            class="bg-white"
            @click.stop="showPlanes = true"
          >
            <van-cell
              style="padding-bottom: 0;"
              :border="false"
              v-for="(info, index) in flights"
              :key="index"
            >
              <div>
                <van-tag
                  round
                  class="tag-green"
                >
                  <span v-show="index == 0 && flights.length > 1">{{ $t('C174', '去程') }}</span>
                  <span v-show="index == 0 && flights.length == 1">{{ $t('C101', '单程') }}</span>
                  <span v-show="index == 1">{{ $t('C175', '返程') }}</span>
                </van-tag>
                <span class="font14 font">
                  {{ info.departDate }} {{ info.departDate | week }}&nbsp;{{ info.departTime }}&nbsp;{{
                    info.cabin.cabinName | cabinName
                  }}
                </span>
                <div class="deep-gray font12">
                  {{ info.departAirportName }}&nbsp;{{ info.departTerminal }} - {{
                    info.arriveAirportName
                  }}&nbsp;{{ info.arriveTerminal }}
                </div>
              </div>
              <div
                class="main-color font12"
                @click.stop="toggle('rule', info,flights)"
              >
                {{ $t('F010', '退改签规则') }}
              </div>
            </van-cell>
          </div>

          <!--出行人 -->
          <traver
            :traveler-list="travelerList"
            :person-list="tkIntSearchInfo.ccsqd.personList"
            :title="$t('C001', '乘机人')"
            cplx="10902"
            element=".TkIntEdit"
          />
          <!-- 保险 -->
          <insurance
            ref="insurance"
            :cxrlength="travelerList.length"
            cplx="10902"
            @selected="insuranceUpdate"
            element=".TkIntEdit"
          />

          <!-- 服务费 -->
          <van-cell :title="$t('E001', '服务费')">
            <div>
              <span class="font16 red"><small>&yen;</small> {{ serviceFee }}</span>*{{
                travelerList.length
              }}人
            </div>
          </van-cell>
          <!-- 差旅信息 -->
          <travel-info
            v-show="tkIntSearchInfo.queryStr.tripType == 1"
            ref="travelinfo"
            @selected="getTavelInfo"
            element=".TkIntEdit"
          />

          <!-- 联系信息 -->
          <div>
            <van-field
              :label="$t('D022', '联系信息')"
              :readonly="true"
              @click="$refs['linker'].toggle()"
            >
              <div slot="input">
                {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})

                <div class="font12 gray">
                  {{ $t('D020', '邮箱') }} ({{ linker.linkEmail }})
                </div>
              </div>
            </van-field>
          </div>

          <!-- 编辑联系人 -->
          <ld-edit-linker
            ref="linker"
            :data="linker"
            @selected="getLinker"
          />

          <div
            class="font12 gray"
            v-if="false"
          >
            点击“提交订单”表示已阅读锂电池规定、禁止危险品乘机说明、智通天行购票须知。
          </div>
        </div>
      </mescroll-vue>
    </div>

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
      class="bg-white shadow"
    >
      <van-row
        type="flex"
        align="center"
        class="full-width"
      >
        <van-col span="1"/>
        <van-col span="8">
          <span class="font12 money-color">&yen;</span>
          <span class="font22 money-color">
            {{ totalprices }}
          </span>
          <span class="font10 gray">{{ $t('E017', '共') }}{{ travelerList.length }}人</span>
        </van-col>
        <van-col span="7">
          <div
            class="font12 text-left"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006', '明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </div>
        </van-col>
        <van-col
          span="8"
          class="pad-r-8"
        >
          <ld-button
            :loading="false"
            size="md"
            main
            @click.native="book"
          >
            {{ $t('F560', '提交订单') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 退改规则 -->
    <refund-change-rule
      ref="rule"
      :obj="changeRule"
      cplx="10902"
    />

    <!-- 行程展示 -->
    <van-popup
      v-model="showPlanes"
      class="full-width"
      :close-on-popstate="true"
    >
      <tk-int-voyage :flights="flights"/>
    </van-popup>

    <!-- 预留改签提示 -->
    <van-dialog
      v-model="showReserved"
      :title="$t('C474', '提示')"
      show-cancel-button
      :confirm-button-text="$t('B012', '继续预订')"
      @confirm="sendAjax"
      @cancel="showReserved = false"
    >
      <div
        v-for="(info, index2) in reservedData"
        :key="index2"
      >
        乘客 <span class="orange">{{ info.psgName }}</span>
        <van-tag
          type="warning"
          v-show="info.fsEmpId"
        >
          {{ $t('attach', '附') }}
        </van-tag>
        存在预留改签的机票； 行程：<span>{{ info.voyageZh }}</span>， {{ info.departTime }}， {{ info.flightNo }}，可联系客服进行改签!
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {Cell, Tag, Popup, Field, Toast, Dialog} from 'vant'
import {mapGetters} from 'vuex'
import ldEditLinker from 'Components/ldEditLinker'
import MescrollVue from 'mescroll.js/mescroll.vue'

import ldHeader from 'Common/ldHeader'
import travelInfo from 'Components/travelInfo'
import insurance from 'Components/insurance'
import refundChangeRule from 'Components/refundChangeRule'
import traver from 'Components/tk/traver'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import {getName, getIdType, getIdNumber} from 'Utils/publicFun'
import tkIntVoyage from 'Views/TkInt/components/voyage'


export default {
  name: 'TkIntEdit',
  components: {
    ldHeader,
    travelInfo,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Field.name]: Field,
    insurance,
    refundChangeRule,
    traver,
    ldTabbar,
    ldButton,
    ldEditLinker,
    MescrollVue,
    tkIntVoyage
  },
  data() {
    return {
      down: {use: false},
      showPlanes: false,
      showPrice: false,
      showReserved: false,
      priceList: [],
      changeRule: {},
      travelInfo: {},
      linker: {
        linkMan: '',
        linkTel: '',
        linkEmail: ''
      },//联系人信息
      insurance: [],
      insurancePrice: 0,
      reservedData: [],
      // totalprices:0,
    }
  },
  computed: {
    ...mapGetters({
      tkIntSearchInfo: 'tkInt/tkIntSearchInfo',
      travelerList: 'tkInt/travelerList',
      tripType: 'tripType',
      pageCtrl: 'serviceCtrl',
      userInfo: 'userInfo',
      sysType: 'sysType'
    }),
    flights() {//当前航班信息
      let ft = this.tkIntSearchInfo.flights
      ft[0].qflightBean.flightReqId = ft[0].flightReqId
      ft[0].qflightBean.flightSn = ft[0].flightSn
      if (ft[1]) {
        ft[1].qflightBean.flightReqId = ft[1].flightReqId
        ft[1].qflightBean.flightSn = ft[1].flightSn
      }
      let f0 = ft[0]
      let f1 = ft[1]
      if (ft.length > 1) {
        return [f0.qflightBean, f1.qflightBean,]
      } else if (f0.hflightBean) {
        return [f0.qflightBean, f0.hflightBean]
      }

      return [f0.qflightBean]
    },
    serviceFee() {//服务费
      let serviceFee = 0
      this.flights.forEach(item => {
        if (item.price) {
          serviceFee = item.price.aduServicefee
        }
      })
      return serviceFee
    },
    tax() {//税费
      let tax = 0
      this.tkIntSearchInfo.flights.forEach(item => {
        if (item.qflightBean.price) {
          tax += item.qflightBean.price.aduTax + item.qflightBean.price.chdTax + item.qflightBean.price.infTax
        }
      })
      return tax
    },
    totalprices() {
      //单程的总价费用
      let price = this.flights[0].price
      let queryStr = this.tkIntSearchInfo.queryStr
      let aduSalePrice = (Number(price.aduSalePrice) + Number(price.aduServicefee) + Number(price.aduTax)) * queryStr.adultNum //成人
      let chdSalePrice = (Number(price.chdSalePrice) + Number(price.chdServicefee) + Number(price.chdTax)) * queryStr.childNum  //儿童
      let infSalePrice = (Number(price.infSalePrice) + Number(price.infServicefee) + Number(price.infTax)) * queryStr.babyNum   //婴儿
      let insurancePrice = this.insurancePrice * this.travelerList.length  //保险费

      return aduSalePrice + chdSalePrice + infSalePrice + insurancePrice
    }
  },
  mounted() {
    /*
        *出差申请单信息回显
        * this.tkIntSearchInfo.ccsqd 存储出差单详情信息
        * this.$refs.travelinfo.getInfo方法 出差申单号回显到页面
        */
    this.$refs.travelinfo.getInfo({...this.tkIntSearchInfo.violate, ...this.tkIntSearchInfo.ccsqd})
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.linker = {
        linkMan: this.userInfo.empInfo.empName,
        linkTel: this.userInfo.empInfo.phoneNumber,
        linkEmail: this.userInfo.empInfo.email
      }
      this.initPrice()
    },
    initPrice() {
      this.initPsgNum()
      //成人总价
      let aduPrice = 0
      //儿童总价
      let chdPrice = 0
      //婴儿总价
      let infPrice = 0
      //票价
      let salePrice = 0
      if (this.tkIntSearchInfo.showIntModel) {
        this.flights.forEach(item => {
          if (item.price) {
            aduPrice += item.price.aduSalePrice + item.price.aduServicefee + item.price.aduTax
            chdPrice += item.price.chdSalePrice + item.price.chdServicefee + item.price.chdTax
            infPrice += item.price.infSalePrice + item.price.infServicefee + item.price.infTax
            salePrice += item.price.aduSalePrice
          }
        })
      } else {
        aduPrice = this.flights[0].price.aduSalePrice + this.flights[0].price.aduServicefee + this.flights[0].price.aduTax
        chdPrice = this.flights[0].price.chdSalePrice + this.flights[0].price.chdServicefee + this.flights[0].price.chdTax
        infPrice = this.flights[0].price.infSalePrice + this.flights[0].price.infServicefee + this.flights[0].price.infTax
        salePrice = this.flights[0].price.aduSalePrice
      }
      //总价
      // this.totalprices=aduPrice + this.insurancePrice * (this.insurance.length * this.tkIntSearchInfo.queryStr.travelType * (this.travelerList.length))
      this.priceList = [

        {
          type: 'spliter',
          name: '-------- ' + this.$t('C115', '成人') + ' --------',
          price: null,
          amount: null,
          unit: '',
          show: this.tkIntSearchInfo.queryStr.adultNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.adultNum > 0
        },
        // 	{
        // 	name: this.$t('C115', '成人'),
        // 	price: aduPrice + this.insurancePrice * (this.insurance.length * this.tkIntSearchInfo.queryStr.travelType * (this.travelerList.length)),
        // 	amount: this.tkIntSearchInfo.queryStr.adultNum, unit: this.$t('E113', '人'),
        // 	show: this.tkIntSearchInfo.queryStr.adultNum > 0 ? true : false
        // },
        // name: this.$t('A008', '机票'),
        {
          name: this.$t('C1150', '票面'),
          price: salePrice,
          amount: this.tkIntSearchInfo.queryStr.adultNum,
          unit: '/' + this.$t('E113', '人'),
          show: this.tkIntSearchInfo.queryStr.adultNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.adultNum > 0
        },
        // { name: '机建', price: this.airportFee, amount: 1, unit: '/人' },
        {
          name: this.$t('Taxation', '税费'),
          price: this.flights[0].price.aduTax,
          amount: this.tkIntSearchInfo.queryStr.adultNum,
          unit: '/' + this.$t('E113', '人'),
          show: this.tkIntSearchInfo.queryStr.adultNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.adultNum > 0
        },
        {
          name: this.$t('E505', '保险'),
          price: this.insurancePrice,
          amount: this.tkIntSearchInfo.queryStr.adultNum,
          unit: this.$t('E501', '份'),
          show: this.tkIntSearchInfo.queryStr.adultNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.adultNum > 0
        },
        {
          name: this.$t('E001', '服务费'),
          price: this.flights[0].price.aduServicefee,
          amount: this.tkIntSearchInfo.queryStr.adultNum,
          unit: '/' + this.$t('E113', '人'),
          show: this.tkIntSearchInfo.queryStr.adultNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.adultNum > 0
        },
        {
          type: 'spliter',
          name: '-------- ' + this.$t('C116', '儿童') + ' --------',
          price: null,
          amount: null,
          unit: '',
          show: this.tkIntSearchInfo.queryStr.childNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.childNum > 0
        },
        {
          name: this.$t('C1150', '票面'),
          price: this.flights[0].price.chdSalePrice,
          amount: this.tkIntSearchInfo.queryStr.childNum,
          unit: '/' + this.$t('E113', '人'),
          show: this.tkIntSearchInfo.queryStr.childNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.childNum > 0
        },
        // { name: '机建', price: this.airportFee, amount: 1, unit: '/人' },
        {
          name: this.$t('Taxation', '税费'),
          price: this.flights[0].price.chdTax,
          amount: this.tkIntSearchInfo.queryStr.childNum,
          unit: '/' + this.$t('E113', '人'),
          show: this.tkIntSearchInfo.queryStr.childNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.childNum > 0
        },
        {
          name: this.$t('E505', '保险'),
          price: this.insurancePrice,
          amount: this.tkIntSearchInfo.queryStr.adultNum,
          unit: this.$t('E501', '份'),
          show: this.tkIntSearchInfo.queryStr.childNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.childNum > 0
        },
        {
          name: this.$t('E001', '服务费'),
          price: this.flights[0].price.chdServicefee,
          amount: this.tkIntSearchInfo.queryStr.childNum,
          unit: '/' + this.$t('E113', '人'),
          show: this.tkIntSearchInfo.queryStr.childNum > 0,
          hideYen: this.tkIntSearchInfo.queryStr.childNum > 0
        },
        // {
        // 	name: this.$t('C116', '儿童'),
        // 	price: chdPrice,
        // 	amount: this.tkIntSearchInfo.queryStr.childNum,
        // 	unit: this.$t('E113', '人'),
        // 	show: this.tkIntSearchInfo.queryStr.childNum > 0 ? true : false
        // },
        {
          name: this.$t('C117', '婴儿'),
          price: infPrice,
          amount: this.tkIntSearchInfo.queryStr.babyNum,
          unit: this.$t('E113', '人'),
          show: this.tkIntSearchInfo.queryStr.babyNum > 0 ? true : false
        },]
      this.tkIntSearchInfo.priceList = this.priceList
    },
    initPsgNum() {
      this.tkIntSearchInfo.queryStr.adultNum = 0
      this.tkIntSearchInfo.queryStr.childNum = 0
      this.tkIntSearchInfo.queryStr.babyNum = 0
      this.travelerList.forEach(item => {
        if (item.psgType == 1 || !item.psgType) {
          this.tkIntSearchInfo.queryStr.adultNum += 1
        } else if (item.psgType == 2) {
          this.tkIntSearchInfo.queryStr.childNum += 1
        } else if (item.psgType == 3) {
          this.tkIntSearchInfo.queryStr.babyNum += 1
        }
      })
    },
    // 获取差旅信息
    getTavelInfo(info) {
      this.travelInfo = info
    },
    //提交订单
    book() {
      if (this.travelerList.length < 1) {
        this.$toast(this.$t('I001', '请选择出行人'))
        return
      }
      if (this.tkIntSearchInfo.violate && this.tkIntSearchInfo.violate.canBook === '0') {
        this.$toast('您选择的出行人违背差旅标准，不允许预订，请重新选择。')
        return
      }
      let support = ['PP', 'GA', 'TW', 'TB'] //支持的类型
      let typesi = this.travelerList.every((item) => support.includes(getIdType(item)))
      console.log("typesi", typesi)
      if (!typesi) {
        this.$toast('证件类型只支持护照、港澳通行证、台湾能行证、台胞证，请您修改类型')
        return
      }
      let bl = this.$refs.travelinfo.result()//判断差旅信息是否填写完整
      if (bl) {
        this.sendAjax()
      }
    },
    // 下单
    sendAjax() {
      Toast.loading({
        message: '加载中...',
        loadingType: 'spinner',
        forbidClick: false,
        duration: 0
      });

      let rangeList = []
      if (this.tkIntSearchInfo.queryStr.travelType == 2) {//往返
        if (this.tkIntSearchInfo.flights.length > 1) {
          rangeList = this.tkIntSearchInfo.flights.map((item, index) => {
            return {
              'flightSn': item.flightSn,
              'flightReqId': item.flightReqId,
              'cabinCode': item.qflightBean.cabin.cabinCode,//舱位代码 如Y,Y不能为空 ,
              'rangeType': index + 1,//去程回程 1去程 2回程 不能为空 如果往返汇合 则传入1 ,
              'recomFlightNo': '',//推荐航班号 ,
              'recomCabin': '',//推荐舱位
              'recomDepartTime': '',// 推荐出发时间 ,
              'recomPrice': 0,//推荐价格
              priceId: item.qflightBean.price.priceId,
              reasonCode: this.travelInfo.reasonCode,
              reasonDesc: this.travelInfo.reasonDesc,
            }
          })
        } else {
          let item = this.tkIntSearchInfo.flights[0]
          rangeList = [
            {
              'flightSn': item.flightSn,
              'flightReqId': item.flightReqId,
              'cabinCode': item.qflightBean.cabin.cabinCode,//舱位代码 如Y,Y不能为空 ,
              'rangeType': 1,//去程回程 1去程 2回程 不能为空 如果往返汇合 则传入1 ,
              'recomFlightNo': '',//推荐航班号 ,
              'recomCabin': '',//推荐舱位
              'recomDepartTime': '',// 推荐出发时间 ,
              'recomPrice': 0,//推荐价格
              priceId: item.qflightBean.price.priceId,
              reasonCode: this.travelInfo.reasonCode,
              reasonDesc: this.travelInfo.reasonDesc,
            }
          ]
        }
      } else {
        rangeList = this.tkIntSearchInfo.flights.map((item, index) => {
          return {
            'flightSn': item.flightSn,
            'flightReqId': item.flightReqId,
            'cabinCode': item.qflightBean.cabin.cabinCode,//舱位代码 如Y,Y不能为空 ,
            'rangeType': index + 1,//去程回程 1去程 2回程 不能为空 如果往返汇合 则传入1 ,
            'recomFlightNo': '',//推荐航班号 ,
            'recomCabin': '',//推荐舱位
            'recomDepartTime': '',// 推荐出发时间 ,
            'recomPrice': 0,//推荐价格
            priceId: item.qflightBean.price.priceId,
            reasonCode: this.travelInfo.reasonCode,
            reasonDesc: this.travelInfo.reasonDesc,
          }
        })
      }
      this.$api['tkIntQuery/bookGj']({
        'postCompId': '',//邮寄公司id
        'postOrderId': '',// 邮寄订单id
        'ifSameOrder': '',
        travelStandard: this.tkIntSearchInfo.queryStr.empRank, //标准差标等级
        tripType: this.tkIntSearchInfo.queryStr.tripType, //因公因私
        rangeType: this.tkIntSearchInfo.queryStr.travelType,
        ccsqdId: this.travelInfo.ccsqdId,
        ccsqdNo: this.travelInfo.ccsqdNo,
        ccsqdRemark: this.travelInfo.ccsqdRemark,
        routeId: this.tkIntSearchInfo.routeId, //行程ID
        subjectCode: this.travelInfo.subjectCode,
        costCenterCode: this.travelInfo.costCenterCode,
        costCenterId: this.travelInfo.costCenterId,
        costCenterName: this.travelInfo.costCenterName,
        linkEmail: this.linker.linkEmail,
        linkman: this.linker.linkMan,
        linkTel: this.linker.linkTel,
        orderFrom: this.sysType,
        postCode: '', //邮编
        projectCode: this.travelInfo.projectCode,
        projectId: this.travelInfo.projectId,
        projectName: this.travelInfo.projectName,
        sendMode: 1, //公司统一配送
        reciAddr: '', //收件地址
        reciPhone: '',
        reciPient: '', //收件人
        psgList: this.travelerList.map((item) => {
          return {
            'nationHx': item.nationHx || item.nation,// 航信国籍 国籍二字码
            'nation': item.nation,
            'passportPeriod': item.passportPeriod,//证件号码有效期不能为空 2017-10-10 ,
            // 'placeOfIssue': item.placeOfIssue,//证件签发地不能为空
            'placeOfIssue': item.nation,

            'fsEmpId': item.fsEmpId,
            'psgName': getName(item),
            'psgType': item.psgType || '1',
            'idType': getIdType(item),
            'idno': getIdNumber(item),
            'phoneNumber': item.phoneNumber,
            'sex': item.sex,
            'born': item.born,
            'empId': item.conempId || item.personId || item.contactsId || item.empId,//顺序不能变
          }
        }),
        rangeList: rangeList
      }).then(res => {
        Toast.clear();
        let cache = res.data || {}
        let bx = this.$refs.insurance.getInsurance()
        cache.arr = cache.orderIds.split(',')
        if (bx && bx.length > 0) {
          this.$api['bx/bookBx']({
            bxcpList: bx,
            cplx: '10902',
            orderId: cache.orderIds
          }).then(() => {
            this.jump(cache)
          })
        } else {
          this.jump(cache)
        }
      }).catch(err => {
        Toast.clear();
      })
    },
    jump(cache) {
      if (cache.arr.length > 1) {
        this.$dialog({
          confirmButtonText: '前往',
          message: '系统生成两个订单前往订单列表查看',
        }).then(() => {
          this.$router.push({
            path: '/allOrder?findType=1',
            query: {findType: 1, productType: '10902'}
          })
        })
      } else {
        this.$router.push({
          path: '/tk/tkIntCmp',
          query: {orderIds: cache.orderIds, priceFlag: cache.priceFlag}
        })
      }
    },
    // 保险
    insuranceUpdate(info) {
      this.insurance = info
      this.insurancePrice = 0
      if (info && info.length > 0) {
        info.forEach(item => {
          this.insurancePrice += item.saleprice
        })
      }
      this.initPrice()
    },
    getLinker(info) {//修改联系人回调
      this.linker = {}
      this.linker = info
    },
    toggle(ref, info, flights) {
      if (info) {//退改规则参数
        this.changeRule = {
          'flightReqId': info.flightReqId,//航班查询请求id不能为空 ,
          'flightSn': info.flightSn,//航班序号
          'cabin': info.cabin.cabinCode,
          'priceId': info.price.priceId,
          'cplx': '10902'
        }
      }
      this.$refs[ref].toggle()
    },
    getClbz() {
      if (this.pageCtrl.isShowCxr) {//判断是否需要获取差标
        this.$store.commit('SET_SERVICE', {cplx: '10902'})
        let clbz = this.pageCtrl.getClbzMinZj(this.travelerList)
        this.tkIntSearchInfo.minzj = clbz.minzj//最低差标等级
        this.tkIntSearchInfo.minzjName = clbz.minzjName//最低差标等级
        let str = {
          arriveAirport: this.tkIntSearchInfo.arrport.threeCode,
          departAirport: this.tkIntSearchInfo.depport.threeCode,
          empRank: this.tkIntSearchInfo.minzj,
          cplx: '10902'
        }
        if (!str.arriveAirport || !str.departAirport || !this.travelerList || this.travelerList.length < 1) {
          return
        }
        try {
          this.$api['tkQuery/GetClzbByMinZj'](str)
            .then(res => {
              let cache = res.data || {}
              if (cache.clbz) {
                if (this.tkIntSearchInfo.clbzTitle != cache.clbz) {
                  this.tkIntSearchInfo.clbzTitle = cache.clbz
                  this.matchClbz()
                }
              } else {
                this.tkIntSearchInfo.clbzTitle = ''
                this.tkIntSearchInfo.violate = {}
                this.tkIntSearchInfo.violateList = []
              }
            })
        } catch (error) {
        }
      }
    },
    // 获取是否违背
    matchClbz() {
      this.$api['tkIntQuery/matchVipClzc']({
        'minZj': this.tkIntSearchInfo.queryStr.empRank || '0',
        'corpId': '',
        'flightReqId': this.tkIntSearchInfo.flights[0].requestId  //航班查询请求id不能为空
      }).then(res => {
        let cache = res.data || {}
        this.tkIntSearchInfo.violateList = cache.priceMap || {}
        let priceId = this.tkIntSearchInfo.flights[0].qflightBean.price.priceId
        if (this.tkIntSearchInfo.violateList[priceId]) {
          Object.assign(this.tkIntSearchInfo.violate, this.tkIntSearchInfo.violateList[priceId])
          this.$refs.travelinfo.getInfo({...this.tkIntSearchInfo.violate})
        } else {
          this.tkIntSearchInfo.violate = {}
          this.tkIntSearchInfo.violateList = []
        }
      })
    },

  },
  filters: {
    productType(type) {
      var obj = {'0': '特价', '1': '', '2': '电商', '3': '协议', '6': ''}//1标准
      return obj[type] || ''
    },
    cabinName(name) {
      if (name) {
        name = name.split(',')
        return [...new Set(name)].join('/')
      }
      return name
    }
  },
  watch: {
    'travelerList.length': {
      handler: function () {
        if (this.travelerList.length > 0) {
          this.travelerList.forEach(item => {
            // item.cardType = 'B'
          })
        }
        this.initPrice()
        this.getClbz()
      },
      immediate: true
    }
  }
}

</script>

<style lang="less" scoped>
@import '~Assets/styles/business';

.TkIntEdit {
}

.pad-r-8 {
  padding-right: 8px;
}

.pad-lr-16 {
  padding-left: 16px;
  padding-right: 16px;
}

.box {
  height: 100%;
  padding: 0 6px 50px;

  > div {
    margin-bottom: 5px;
  }

  .plane {
    height: 1.2rem;
  }
}

.tkIntEditwrapper {
  height: calc(100vh - 96px);
  overflow: hidden;
}
</style>
